import React, {  useState } from "react";
import { Helmet } from "react-helmet";

// import Custom Components
import Breadcrumb from "../../common/breadcrumb";
import { toast } from "react-toastify";
import { confirmResetToken, sendResetLink } from "../../../api";
import Loader from "../../common/loader";
import { useNavigate } from "react-router-dom";

function ForgetPassword() {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  handleScrollToTop();
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginForm({
      ...loginForm,
      [name]: value,
    });
  };

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const resetLink = urlParams.get("reset-link-sent");
  //   ?reset-link-sent=true
  //   console.log(resetLink);
  //   useEffect(() => {
  //     // Get the token from the URL query parameters
  //     // Redirect to another page or perform any other actions
  //     // history.push("/dashboard");
  //   }, [resetLink]);
  if (resetLink) {
    return (
      <>
        <div className="main">
          <Helmet>
            <title>LIBER - Signin/Register </title>
          </Helmet>

          <h1 className="d-none">LIBER - Signin/Register</h1>

          <Breadcrumb
            title="Login"
            parent1={["pages", "pages/about"]}
            adClass="border-0 mb-0"
          />

          <div
            className="login-page bg-image pt-8 pb-8 pt-md-12 pb-md-12 pt-lg-17 pb-lg-17"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/backgrounds/login-bg.jpg)`,
            }}
          >
            <div className="container">
              <div className="form-box">
                <div className="form-tab">
                  <div className="form-group">
                    <h2>Password reset email has been sent.</h2>
                    <p>
                      A password reset email has been sent to the email address,
                      but may take several minutes to show up in your inbox.
                      Please wait at least 10 minutes before attempting another
                      reset.
                    </p>
                    <div className="form d-flex justify-content-between align-items-center py-3">
                      <button
                        className="btn btn-outline-primary-2"
                        onClick={() => navigate(`/`)}
                      >
                        <span>HOME</span>
                        <i className="icon-long-arrow-right"></i>
                      </button>
                      <a href="/login" className="forgot-link">
                        return to Login
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  //   const [selectedTab, selectTab] = useState(0);
  //   console.log(selectedTab);

  const HandlesendResetLink = async (e) => {
    e.preventDefault();
    setloading(true);
    const data = { email: loginForm.email };
    const res = await sendResetLink(data);
    setloading(false);
    if (res) {
      toast.success("Reset Password Sent Sucessfully");
      setTimeout(() => {
        window.location.href = "/resetPassword?reset-link-sent=true";
      }, 2000);
    }
  };
  const HandlesendsetPassword = async (e) => {
    e.preventDefault();
    setloading(true);
    if (loginForm.confirmPassword !== loginForm.password) {
      setloading(false);
      return toast.error("Password not matched");
    }
    const data = { token: token, password: loginForm.confirmPassword };
    const res = await confirmResetToken(data);
    setloading(false);
    if (res) {
      toast.success("Password Changed Sucessfully");
      setTimeout(() => {
        navigate(`/login`);
        // window.location.href = "/resetPassword?reset-link-sent=true";
      }, 2000);
    }
  };
  return (
    <div className="main">
      {loading && <Loader />}

      <Helmet>
        <title>LIBER - Signin/Register </title>
      </Helmet>

      <h1 className="d-none">LIBER - Signin/Register</h1>

      <Breadcrumb
        title="Login"
        parent1={["pages", "pages/about"]}
        adClass="border-0 mb-0"
      />

      <div
        className="login-page bg-image pt-8 pb-8 pt-md-12 pb-md-12 pt-lg-17 pb-lg-17"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/backgrounds/login-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="form-box">
            <div className="form-tab">
              {token ? (
                <>
                  <form onSubmit={HandlesendsetPassword}>
                    <div className="form-group">
                      <label htmlFor="singin-email-2">Enter Password *</label>
                      <input
                        type="text"
                        className="form-control"
                        id="singin-email-2"
                        name="password"
                        value={loginForm.password}
                        onChange={handleInputChange}
                        required
                      />
                      <label htmlFor="singin-email-2">Confirm Password *</label>
                      <input
                        type="text"
                        className="form-control"
                        id="singin-email-2"
                        name="confirmPassword"
                        value={loginForm.confirmPassword}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="form d-flex justify-content-between align-items-center">
                      <button
                        type="submit"
                        className="btn btn-outline-primary-2"
                      >
                        <span>RESET PASSWORD</span>
                        <i className="icon-long-arrow-right"></i>
                      </button>
                      <a href="/login" className="forgot-link">
                        return to Login
                      </a>
                    </div>
                  </form>
                </>
              ) : (
                <>
                  <div>
                    <form onSubmit={HandlesendResetLink}>
                      <div className="form-group">
                        <label htmlFor="singin-email-2">Email address *</label>
                        <input
                          type="text"
                          className="form-control"
                          id="singin-email-2"
                          name="email"
                          value={loginForm.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form d-flex justify-content-between align-items-center">
                        <button
                          type="submit"
                          className="btn btn-outline-primary-2"
                        >
                          <span>SEND RESET PASSWORD LINK</span>
                          <i className="icon-long-arrow-right"></i>
                        </button>
                        <a href="/login" className="forgot-link">
                          return to Login
                        </a>
                      </div>
                    </form>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(ForgetPassword);
